export default __webpack_public_path__ + "static/media/23-7147797.bc90ac2b.png";